import "@testing-library/jest-dom";
import React from "react";
import { fireEvent, render, screen, waitFor } from "@testing-library/react";
import { ChatPanel } from "./ChatPanel";

const mockCancelStream = jest.fn(async () => undefined);
const mockProviderConfigs: Array<Record<string, unknown>> = [];
let mockChatState: Record<string, unknown> = {};

jest.mock("@metalmind-ab/mmagent-chat-ui/styles.css", () => ({}), {
  virtual: true,
});
jest.mock("@metalmind-ab/mmagent-chat-ui", () => {
  const actual = jest.requireActual("@metalmind-ab/mmagent-chat-ui");
  return {
    ...actual,
    ChatProvider: (props: { config: Record<string, unknown> }) => {
      mockProviderConfigs.push(props.config);
      return actual.ChatProvider(props);
    },
    useChat: () => ({
      messages: [],
      sendMessage: jest.fn(),
      cancelStream: mockCancelStream,
      isLoading: true,
      isStopping: false,
      stopError: null,
      ...mockChatState,
    }),
  };
});
jest.mock("../../../../hooks/useAuthHeaders", () => ({
  useAuthHeaders: () => async () => ({ Authorization: "test-token" }),
}));
jest.mock("../../../../config/runtimeConfig", () => ({
  getApiBaseUrl: () => "http://localhost",
}));
jest.mock("../../../../utils/chatResumeOptions", () => ({
  buildChatResumeOptions: () => ({}),
}));

const originalFetch = global.fetch;

beforeEach(() => {
  mockProviderConfigs.length = 0;
  mockCancelStream.mockClear();
  mockChatState = {};
  Object.defineProperty(HTMLElement.prototype, "scrollIntoView", {
    configurable: true,
    value: jest.fn(),
  });
  global.fetch = jest.fn(
    async () =>
      ({ ok: true, json: async () => ({ items: [], total: 0 }) }) as Response,
  ) as unknown as typeof fetch;
});

afterEach(() => {
  global.fetch = originalFetch;
});

it("configures server-confirmed Stop for the BKG chat route", async () => {
  render(<ChatPanel workspaceId="workspace-1" />);
  await waitFor(() => expect(mockProviderConfigs.length).toBeGreaterThan(0));
  expect(mockProviderConfigs[0].cancelSubmission).toBe(true);
  expect(mockProviderConfigs[0].headers).toMatchObject({
    "X-Workspace-Id": "workspace-1",
  });
  fireEvent.click(
    await screen.findByRole("button", { name: /stop generating/i }),
  );
  expect(mockCancelStream).toHaveBeenCalledTimes(1);
});

it("keeps BKG Stop available after an unconfirmed server answer", async () => {
  mockChatState = {
    stopError: "Only the person who started this response can stop it.",
  };
  render(<ChatPanel workspaceId="workspace-1" />);
  expect(
    await screen.findByText(
      "Only the person who started this response can stop it.",
    ),
  ).toBeInTheDocument();
  expect(
    await screen.findByRole("button", { name: /stop generating/i }),
  ).toBeEnabled();
});

it("disables BKG Stop while confirmation is pending", async () => {
  mockChatState = { isStopping: true };
  render(<ChatPanel workspaceId="workspace-1" />);
  expect(
    await screen.findByRole("button", { name: /stopping/i }),
  ).toBeDisabled();
});
